import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-ov-typo",
  templateUrl: "./ov-typo.component.html",
  styleUrls: ["./ov-typo.component.scss"],
})
export class OvTypoComponent implements OnInit {
  colours = [
    {
      swatch: "#db4a83",
      code: "#db4a83",
    },
    {
      swatch: "#8061a5",
      code: "#8061a5",
    },
    {
      swatch: "#ed8405",
      code: "#ed8405",
    },
    {
      swatch: "#dd3820",
      code: "#dd3820",
    },
    {
      swatch: "#d4d607",
      code: "#d4d607",
    },
    {
      swatch: "#0f8734",
      code: "#0f8734",
    },
  ];
  constructor() {}

  ngOnInit() {}
}
